import axios from 'axios';
// write a helper function to debounce a function

export const getAirtimeAccessToken = async () => {
  const airtimeAccessToken = JSON.parse(
    localStorage.getItem('reloadlyAirtimeAccessToken'),
  );
  const airtimeAccessTokenExpiration = JSON.parse(
    localStorage.getItem('reloadlyAirtimeAccessTokenExpiration'),
  );
  console.log('[airtime][token] cache check', {
    hasCachedToken: !!airtimeAccessToken?.access_token,
    hasExpiration: !!airtimeAccessTokenExpiration,
    now: new Date().getTime(),
    expiration: airtimeAccessTokenExpiration || null,
  });

  if (
    !airtimeAccessToken ||
    new Date().getTime() > airtimeAccessTokenExpiration * 0.7
  ) {
    try {
      //   console.log(process.env.REACT_APP_RELOADLY_AIRTIME_AUDIENCE);
      const airtimeAccessTokenObject = await axios.post(
        'https://auth.reloadly.com/oauth/token',
        {
          client_id: process.env.REACT_APP_RELOADLY_CLIENT_ID,
          client_secret: process.env.REACT_APP_RELOADLY_CLIENT_SECRET,
          grant_type: 'client_credentials',
          audience:
            process.env.REACT_APP_RELOADLY_AIRTIME_AUDIENCE ||
            'https://topups.reloadly.com',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      );

      const newAccessToken = airtimeAccessTokenObject.data;
      // console.log(newAccessToken, airtimeAccessTokenObject.data.access_token);
      const newExpirationTime =
        new Date().getTime() + newAccessToken.expires_in * 1000;

      localStorage.setItem(
        'reloadlyAirtimeAccessToken',
        JSON.stringify(newAccessToken),
      );
      localStorage.setItem(
        'reloadlyAirtimeAccessTokenExpiration',
        JSON.stringify(newExpirationTime),
      );
      console.log('[airtime][token] fetched new token', {
        hasToken: !!newAccessToken?.access_token,
        expiresIn: newAccessToken?.expires_in || null,
      });

      return newAccessToken;
    } catch (err) {
      console.error('[airtime][token] fetch failed', {
        status: err?.response?.status || null,
        data: err?.response?.data || null,
        message: err?.message || null,
      });
      return null;
    }
  }

  console.log('[airtime][token] using cached token');
  return airtimeAccessToken;
};
